import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, adminRequired = false }) => {
  const { currentUser, loading } = useContext(AuthContext);

  if (loading) {
    // Show loading spinner while authentication state is loading
    return <LoadingSpinner message="Verifying authentication..." />;
  }

  if (!currentUser) {
    // Redirect to login if user is not authenticated
    return <Navigate to="/login" />;
  }

  // Check if admin access is required
  if (adminRequired && !currentUser.isAdmin) {
    // Redirect to collection if user is not an admin
    return <Navigate to="/collection" />;
  }

  // If authenticated and meets admin requirements, render the child component(s)
  return children;
};

export default ProtectedRoute;